export type CreateDeploymentRequestDataKindNamesRequest = {
  dataKindIdList: DataKindRequest[];
  forceStgDplyFlg: boolean;
  dfnSetVerNum: string;
};

export type DataKindRequest = {
  index: number;
  dtKindId: string;
};
